<div class="container-fluid row col-12 no-gutters">
  <div class="col-xl-9 col-md-9 col-sm-12 col-12 no-gutters">
    <form [formGroup]="RenTMForm" class="col-xl-9 col-md-9 col-sm-12 col-12 m-auto no-gutters">
      <h6 class="col-12 mb-3 text-normal"><strong>Application
          Description</strong>
      </h6>
      <div class="col-12 text-normal mb-3">RenTM is a transportation management system specifically
        designed to support EU Onshore Wind Outbound logistics. The application tracks shipment location, cost, etc.
      </div>
      <h6 class="col-12 text-normal"><strong>Registration
          Question</strong>
      </h6>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">
          <span>
            First Name
            <span style="color: red;">*</span>
          </span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input formControlName="firstName" name="firstName" matInput #firstName placeholder="" maxlength="50">
          <mat-hint align="end">{{firstName.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">
          <span>
            Last Name
            <span style="color: red;">*</span>
          </span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input formControlName="lastName" name="lastName" matInput #lastName placeholder="" maxlength="50">
          <mat-hint align="end">{{lastName.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">Work Email Address
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input formControlName="email" name="email" matInput #email placeholder="" maxlength="50">
          <mat-hint align="end">{{email.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">Company Name
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input formControlName="companyName" name="companyName" matInput #companyName placeholder="" maxlength="50">
          <mat-hint align="end">{{companyName.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">Mobile Phone
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input formControlName="mobilePhone" name="mobilePhone" matInput #mobilePhone placeholder="" maxlength="50">
          <mat-hint align="end">{{mobilePhone.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">Office Phone</div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input formControlName="officePhone" name="officePhone" matInput #officePhone placeholder="" maxlength="50">
          <mat-hint align="end">{{officePhone.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">SSO ID
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input formControlName="ssoID" name="ssoID" matInput #ssoID placeholder="" maxlength="50">
          <mat-hint align="end">{{ssoID.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">Which region do you need access to?
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <mat-select formControlName="region">
            <mat-option value="North America">North America</mat-option>
            <mat-option value="Other (EMEA, Japan, India, Australia)">Other (EMEA, Japan, India, Australia)</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal pb-2">What access is needed?
          <span style="color: red;">*</span>
        </div>
        <mat-checkbox class="example-margin" formControlName="lsp" class="col-12 justify-content-center text-normal"
          [color]="color" (change)="setAll($event.checked)">Logistics service providers (LSP)
        </mat-checkbox>
        <ul class="text-normal mb-0 mt-0">
          <li *ngFor="let itemForm of RenTMForm['controls'].access['controls']">
            <div [formGroup]="itemForm">
              <mat-checkbox (change)="setAll($event.checked, itemForm.controls.name.value); updateAllComplete()" 
                [color]="color" formControlName="value" name="value">
                {{itemForm.value?.name}}
              </mat-checkbox>
            </div>
            <ng-container *ngIf="itemForm.value.name === 'Customs broker'">
              <ul class="text-normal mb-0 mt-0">
                <li *ngFor="let customSub of CustomSubForm.controls">
                  <div [formGroup]="customSub">
                    <mat-checkbox (change)="updateAllComplete()" [color]="color" formControlName="value" name="value">
                      {{customSub.value?.name}}
                    </mat-checkbox>
                  </div>
                </li>
              </ul>
            </ng-container>
          </li>
        </ul>
        <mat-checkbox class="example-margin" formControlName="suppliers"
          class="col-12 justify-content-center text-normal" [color]="color">Components vendors (suppliers)
        </mat-checkbox>
      </div>
      <div class="row no-gutters col-12 d-flex align-items-center justify-content-center py-4">
        <button class="btn btn-primary btn-vernova button col-xl-5 col-md-6 col-sm-12 col-12 text-normal" style="font-size: 18px;"
          (click)="submitRenTMForm()">
          <span>
            Request Access
          </span>
        </button>
      </div>
    </form>
  </div>
  <div class="col-sm-12 col-md-3 col-xl-3 no-gutters">
    <div class="row no-gutters col-12 align-items-center justify-content-center d-none d-sm-block">
      <button class="btn btn-primary btn-vernova button col-12" style="font-size: 18px;" (click)="goToApplication()">
        <span>
          Go To Application
          <i class='fa fa-sign-out pl-2' style="color: #fff;"></i>
        </span>
      </button>
    </div>
    <hr>
    <div class="col-12">
      <h6>
        <strong class="mt-3 text-lable">
          Support
        </strong>
      </h6>
      <div class="col-12 mt-3 p-0 text-normal d-block d-sm-none">
        <button class="btn btn-primary btn-vernova button col-12" style="font-size: 18px;" (click)="goToApplication()">
          <span>
            Go To Application
            <i class='fa fa-sign-out pl-2' style="color: #fff;"></i>
          </span>
        </button>
        <hr>
      </div>
      <div class="col-12 mt-3 p-0 text-normal">
        RenTM Support (<a href="mailto:rentm_support@ge.com" style="word-wrap: break-word;" class="text-highlight">RenTM_support@ge.com</a>)
      </div>
    </div>
    <hr>
    <div class="d-flex col-12 no-gutters">
      <h6><strong class="mt-3 text-lable">Request Created</strong></h6>
      <div id="refresh" class="header-links ml-auto" style="padding-right: 2px;">
        <i class="fa fa-refresh" style="cursor: pointer; color: #005E60;"
        (click)="getListTicket($event)"></i>
      </div>
    </div>
    <div class="col-12 border-box no-gutters d-flex align-items-center justify-content-center">
      <div class="col-11 no-gutters">
        <div class="col-12 text-normal no-gutters" *ngFor="let item of request; let first = first; let last = last">
          <div class="pt-3 col-12" *ngIf="first">
            <div>
              Request submitted at
            </div>
            <div>
              {{item?.date | date:'medium'}}
            </div>
          </div>
          <div class="col-12" *ngIf="!first">
            <div>
              Request submitted at
            </div>
            <div>
              {{item?.date | date:'medium'}}
            </div>
          </div>
          <div class="py-2">
            <div>
              Request ID number:
            </div>
            <div>{{item?.number}}</div>
            <!-- <a href="{{item?.requestUrl}}" target="_blank">
              {{item?.number}}
            </a> -->
          </div>
          <div class="pb-3" *ngIf="last && item?.status">
            <div>Status: </div>
            <div>{{item?.status}}</div>
          </div>
          <div *ngIf="!last && item?.status">
            <div>Status: </div>
            <div>{{item?.status}}</div>
          </div>
          <hr *ngIf="!last">
        </div>
      </div>
    </div>
  </div>
</div>